import { useState, useEffect } from "react";
import { Box, Button, TextField, Radio, Typography } from "@mui/material";
import { UseDiscountManagment } from "../UseDiscountManagment";
import SearchComOff from "../../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import { useSnackbar } from "notistack";
import DeleteRow from "../../../components/DeleteRow";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddBatchDisccount(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { addBatchDiscount, deleteDirectDiscount } = UseDiscountManagment();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    productID: undefined,
    expiredate: true,
    productLimit: 0,
    discountPercent: undefined,
    discountCost: undefined,
  });

  return (
    <Box>
      <Typography color="secondary" sx={{ mb: 2 }} variant="subtitle1">
        افزودن تخفیف
      </Typography>
      <Box
        sx={{
          mb: 2,
          borderRadius: 3,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 10"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 2,
            }}
          >
            <SearchComOff
              sell
              article={isSmall ? true : false}
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <TextField
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={state.discountPercent ? state.discountPercent : ""}
                label="درصد تخفیف"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({
                    ...state,
                    discountPercent: Number(evt.target.value),
                  });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={state.discountCost ? state.discountCost : ""}
                label="قیمت تخفیف"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, discountCost: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box gridColumn="span 11">
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mr: 5 }}>
              <Radio
                checked={state.expiredate == true}
                onChange={() => {
                  setState({
                    ...state,
                    expiredate: true,
                    productLimit: "",
                  });
                }}
              />
              <Typography
                onClick={() => {
                  setState({
                    ...state,
                    expiredate: true,
                  });
                }}
                sx={{
                  color: !state.expiredate ? "gray" : "",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                variant="subtitle1"
              >
                تاریخ انقضا
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mr: 5 }}>
              <Radio
                checked={state.expiredate == false}
                onChange={() => {
                  setState({
                    ...state,
                    expiredate: false,
                  });
                }}
                value="a"
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
              />
              <TextField
                disabled={state.expiredate ? true : false}
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={state.productLimit ? state.productLimit : ""}
                label="تعداد"
                size="small"
                type="number"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, productLimit: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                // width: "100%",
                gap: 2,
              }}
            >
              <Button
                disabled={
                  !state.productID || !state.discountPercent ? true : false
                }
                sx={{ width: "70px" }}
                variant="contained"
                onClick={() => {
                  if (!state.productID || !state.discountPercent) {
                    enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (!state.expiredate && !state.productLimit) {
                    enqueueSnackbar("تعداد را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addBatchDiscount(state, (calback) => {
                    setState({
                      productID: undefined,
                      productLimit: undefined,
                      discountPercent: undefined,
                      discountCost: undefined,
                    });
                    props.callback();
                  });
                }}
              >
                افزودن
              </Button>
              <Button
                sx={{ width: "70px" }}
                variant="contained"
                color="error"
                disabled={!state.productID}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: "تخفیف این محصول",
                    productID: state.productID,
                  });
                }}
              >
                حذف
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={""}
        callback={() => {
          var model = {
            productID: deleteState.productID,
          };
          deleteDirectDiscount(model, () => {
            setState({
              productID: undefined,
              productLimit: undefined,
              discountPercent: undefined,
              discountCost: undefined,
            });
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
